import styled from 'styled-components';
import { AlertViewIcon } from '../icon/icon';
import { useRecoilValue } from 'recoil';
import { authState } from '../../atoms/authState';
import { useHistory } from 'react-router-dom';

// {
//     id: 5,
//     sendAuth: '공주 우진 담당자',
//     createDate: '2024-05-11',
//     contentsTxt: '“2024-04-25 10시 00분” 공주 우진 발주 작업이  취소되었습니다',
//   },

interface FetchSendNotificationResponse {
  orderId: number;
  obtainId: number;
  vehicle?: string;
  name: string;
  content: string;
  createdAt: string;
}

interface DataPropsItems {
  datas: FetchSendNotificationResponse[];
}

export const AlertDataSection = ({ datas }: DataPropsItems) => {
  const auth = useRecoilValue(authState);
  const history = useHistory();

  const clickHandler = (orderId: number) => {
    history.push(`/order/detail/${orderId}`);
  };
  return (
    <ComponentSection>
      <ul>
        {datas.map((item, i) => (
          <li
            key={i}
            onClick={() => {
              clickHandler(item.orderId);
            }}
          >
            <div className="t-box">
              <div className="l-box">
                <div className="icon-box">
                  <AlertViewIcon />
                </div>
                {auth.userType === 'driver' ? (
                  item.vehicle ? (
                    <div className="send-auth">{item.vehicle}</div>
                  ) : (
                    <div className="send-auth">{item.name} 담당자님</div>
                  )
                ) : item.vehicle ? (
                  <div className="send-auth">{item.vehicle}</div>
                ) : (
                  <div className="send-auth">{item.name} 담당자님</div>
                )}
              </div>
              <div className="r-box">
                <div className="date">{item.createdAt}</div>
              </div>
            </div>
            <div className="b-box">{item.content}</div>
          </li>
        ))}
      </ul>
    </ComponentSection>
  );
};

//style
const ComponentSection = styled.section`
  ul {
    li {
      padding: 2.4rem 1.6rem 2.7rem 1.3rem;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      border-bottom: 1px solid ${(props) => props.theme.gray300};
      .t-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .l-box {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          .icon-box {
            display: flex;
          }
          .send-auth {
            font-size: 1.4rem;
            font-weight: 700;
            color: ${(props) => props.theme.textBlackColor};
          }
        }
        .r-box {
          .date {
            font-size: 1.1rem;
            font-weight: 700;
            color: ${(props) => props.theme.textAAAColor};
          }
        }
      }
      .b-box {
        font-size: 1.3rem;
        font-weight: 400;
        color: ${(props) => props.theme.gray500};
      }
    }
  }
`;
